<template>
  <div v-loading="loading">
    <el-form key="formStudentSelector" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :inline="true" :rules="rules" :model="data"
      label-width="100px">
      <el-form-item label="" prop="Keyword">
        <el-input class="cs-studentSelector-searchInput" v-model="data.Keyword" placeholder="请输入学生电话"></el-input>
        <el-button size="small" type="primary" @click="onSearch()" class="margin-left-20px">查找</el-button>
      </el-form-item>
      <el-form-item label="课程类型" prop="CourseType">
        <el-select :disabled="readonly || courseTypeDisabled" v-model="data.CourseType" placeholder="请选择课程类型" class="input-width" @change="onCourseTypeChange">
          <el-option v-for="(item, index) in courseTypeList" :key="index" :label="item.desc" :value="item.value" :disabled="!item.haveCourses" />
        </el-select>
      </el-form-item>
      <el-form-item label="课程" prop="CourseKey">
        <el-select :disabled="readonly || courseKeyDisabled" v-model="data.CourseKey" placeholder="请选择课程" class="input-width"
          @change="onCurrentCourseKeyChange">
          <el-option v-for="(item, index) in courseList" :key="index" :label="item.text" :value="item.value" />
        </el-select>
      </el-form-item>
    </el-form>

    <el-row class="sign-table-container">
      <el-table v-if="!loading" ref="signInMgTable" height="55vh" :data="pageListData" stripe style="width: 100%; " :cell-class-name="cellStyle"
        header-row-class-name="el-table-header" :row-class-name="tableRowClassName">
        <el-table-column prop="_isSelected" fixed width="80" header-align="center" align="center" :render-header="renderSelectHeader">
          <template slot-scope="scope">
            <el-checkbox size="small" v-model="scope.row._isSelected" :disabled="isEdit && scope.row._hasBeenSent"
              @change="(value) => onStudentSelectedChange(value, scope.row.StudentId)" />
          </template>
        </el-table-column>
        <el-table-column prop="StudentName" fixed label="手机号码" width="160" header-align="center" align="center">
          <template slot-scope="scope">
            <span :class="'student-' + scope.row.StudentId">{{ scope.row.StudentName }}</span>
            <span v-if="scope.row._hasBeenSent" class="cs-redLabe">(已发送)</span>
            <!-- <span v-if="scope.row.IsRefund" class="cs-redLabel">(退课)</span> -->
          </template>
        </el-table-column>

        <el-table-column v-for="(week, weekIndex) in tableData.SignInMgtWeekList" :key="weekIndex" :render-header="renderWeekHeader" ref="signInMgtWeekList"
          :label="week.WeekText + '|' + week.DateText + '|' + week.CourseActivationList.length + '|' + weekIndex" width="150" header-align="center">
          <el-table-column :render-header="(h, obj) => renderGroupHeader(h, obj, group)" header-align="center"
            :label="week.WeekText + '|' + weekIndex + '|' + indexGroup" v-for="(group, indexGroup ) in getMergeGroup(week.CourseActivationList)"
            :key="indexGroup">
            <el-table-column v-for="(course, indexCourse) in group" :class-name="!course.IsNotSignIn ? '' : 'cs-signInManage-grey'"
              :render-header="(h, obj) => renderCourseHeader(h, obj, course)" :key="indexCourse"
              :label="course.CourseActivationId + '|' + course.ActiveTimeText + (!course.IsNotSignIn ? '' : '(不计签到)')" header-align="center"
              :width="week.CourseActivationList.length > 0 ? 240 : 150">
              <template slot-scope="scope">
                <signInMangeEditCourse
                  :dataIn="{ isView: isView || course.IsNotSignIn, hasSignIn: !course.IsNotSignIn, summaryEditable: !isView, scope: scope, course: course, week: week, tableData: tableData, courseCategoryList: courseCategoryList }">
                </signInMangeEditCourse>
              </template>
            </el-table-column>

            <el-table-column v-if="group.length > 1" label-class-name="merge-column-title" label="合并课程" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <signInMangeMergeCourse :dataIn="{ isView: isView, scope: scope, group: group, week: week, tableData: tableData }">
                </signInMangeMergeCourse>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="缺勤率" header-align="center" align="center" v-if="!!absenceCourseWeek[week.Week]">
            <template slot-scope="scope">
              <el-row class="text-center">
                <span>{{ getAbsenceCourseWeekForStudent(week.Week, scope.row.StudentId) }}</span>
              </el-row>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column prop="AbsentCount" label="缺课" header-align="center" align="center">
          <template slot-scope="scope">
            <el-row class="text-center" v-if="scope.row.StudentId < 0">
              <span> {{ getTotalAbsentCount(scope) }} </span>
            </el-row>
            <el-row class="text-center" v-if="scope.row.StudentId > 0">
              <span>{{ scope.row.AbsentCount }}</span>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="TruancyCount" label="旷课" header-align="center" align="center">
          <template slot-scope="scope">
            <el-row class="text-center" v-if="scope.row.StudentId < 0">
              <span> {{ getTotalTruancyCount(scope) }} </span>
            </el-row>
            <el-row class="text-center" v-if="scope.row.StudentId > 0">
              <span>{{ scope.row.TruancyCount }}</span>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="LateCount" label="缺时" header-align="center" align="center">
          <template slot-scope="scope">
            <el-row class="text-center" v-if="scope.row.StudentId < 0">
              <span> {{ getTotalLateCount(scope) }} </span>
            </el-row>
            <el-row class="text-center" v-if="scope.row.StudentId > 0">
              <span>{{ scope.row.LateCount }}</span>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="AttendancePercentage" label="出勤率" header-align="center" align="center">
          <template slot-scope="scope">
            <el-row class="text-center" v-if="scope.row.StudentId < 0">
              <span> {{ getTotalAttendancePercentage(scope) }}% </span>
            </el-row>
            <el-row class="text-center" v-if="scope.row.StudentId > 0">
              <span>{{ scope.row.AttendancePercentage ? scope.row.AttendancePercentage : 0 }}%</span>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="AttendancePercentage" label="缺勤率" header-align="center" align="center">
          <template slot-scope="scope">
            <el-row class="text-center" v-if="scope.row.StudentId < 0">
              <span> {{ getTotalAbsentPercentage(scope) }}% </span>
            </el-row>
            <el-row class="text-center" v-if="scope.row.StudentId > 0">
              <span>{{ scope.row.AbsentPercentage ? scope.row.AbsentPercentage : 0 }}%</span>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="displayPagination" class="cs-pagination" background @size-change="pageSizeChange" @current-change="currentPageChange"
        :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import { getTeacherAllCourseList } from "@/service/teacherCourse.service";
import {
  getSignInManagementData,
  getTeacherCourseAttendanceInWeek,
} from "@/service/signInManage.service";
import { componentsToDebugString } from "@fingerprintjs/fingerprintjs";

const mixin_signInMangeTableMethods = {
  components: {
    signInMangeEditCourse: () =>
      import("@/components/signInManage/signInMangeEditCourse"),
    signInMangeMergeCourse: () =>
      import("@/components/signInManage/signInMangeMergeCourse"),
  },
  data() {
    return {
      tableData: {},
      isView: true,
      courseCategoryList: [],
      selectedWeekList: [],
      selectedCourseActivationIdList: [],
      selectedCourseList: [],
      absenceCourseWeek: {},
      isSaveAttendance: false,
      displayPagination: false,
      pageSize: Number.maxValue.int32,
      currentPage: 1,
      recordTotal: 0,
      pageListData: [],
      isAllSelected: false,
      isIndeterminate: false,
    };
  },
  methods: {
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.tableData.SignInMgtStudentList.length - 1) {
        return "cs-signInManage-lastRow";
      }

      return "";
    },
    loadAbsenceCourseWeek(weekNumber) {
      getTeacherCourseAttendanceInWeek(
        null,
        this.USERMANAGER.teacherId,
        this.data.CourseId,
        this.data.CampusId,
        weekNumber
      ).then((result) => {
        if (!!result && result.success) {
          if (!this.absenceCourseWeek) {
            this.absenceCourseWeek = {};
          }

          this.$set(this.absenceCourseWeek, weekNumber, result.data);
        }
      });
    },
    getAbsenceCourseWeekForStudent(weekNumber, studentId) {
      if (studentId == 0) return "";
      if (!!this.absenceCourseWeek) {
        let list = this.absenceCourseWeek[weekNumber];
        let itemData = list.filter((i) => i.StudentId == studentId);
        if (!!itemData && itemData.length > 0) {
          return itemData[0].AbsentPercentage + "%";
        }
      }
      return "";
    },
    renderSelectHeader(createElement, { column }) {
      const _self = this;
      return createElement("el-checkbox", {
        props: {
          size: "mini",
          value: _self.isAllSelected,
          indeterminate: _self.isIndeterminate,
        },
        on: {
          change(value) {
            if (value) {
              for (let i = 0; i < _self.pageListData.length; i++) {
                const row = _self.pageListData[i];
                _self.$set(row, "_isSelected", true);

                if (
                  _self.studentsNotSent.some(
                    (item) => item.StudentId === row.StudentId
                  )
                )
                  continue;

                let evStudentList = _self.studentsNotSent.filter(
                  (student) => student.StudentId === row.StudentId
                );
                if (evStudentList.length === 0) {
                  _self.data.Students.push({
                    StudentId: row.StudentId,
                    HasBeenSent: false,
                  });
                }
              }

              _self.isAllSelected = value;
              _self.isIndeterminate = false;
            } else {
              for (let i = 0; i < _self.pageListData.length; i++) {
                const row = _self.pageListData[i];
                if (row._hasBeenSent) continue;

                _self.$set(row, "_isSelected", false);

                let evStudentList = _self.studentsNotSent.filter(
                  (student) => student.StudentId === row.StudentId
                );
                if (evStudentList.length > 0) {
                  evStudentList.forEach((evStudent) => {
                    _self.data.Students.remove(evStudent);
                  });
                }
              }

              let haveSelected = _self.pageListData.some(
                (item) => item._isSelected
              );
              let haveUnselected = _self.pageListData.some(
                (item) => !item._isSelected
              );
              _self.isAllSelected = haveSelected && !haveUnselected;
              _self.isIndeterminate = haveSelected && haveUnselected;
            }
          },
        },
      });
    },
    renderWeekHeader(createElement, { column }) {
      if (column.label.split("|")[2] == 0) {
        return createElement(
          "div",
          {
            class: {
              "header-week": true,
              "header-not-active": true,
            },
          },
          [
            createElement("a", [column.label.split("|")[0]]),
            createElement("br"),
            createElement("a", [column.label.split("|")[1]]),
          ]
        );
      }

      let _self = this;
      let oDiv = createElement(
        "div",
        {
          class: {
            "header-week": true,
            "header-not-active": column.label.split("|")[2] == 0,
          },
        },
        [
          createElement("a", [column.label.split("|")[0]]),
          createElement("br"),
          createElement("a", [column.label.split("|")[1]]),
          createElement("br"),
          createElement(
            "el-button",
            {
              props: {
                size: "mini",
                type: "primary",
              },
              attrs: {
                style: "display: none;",
              },
              on: {
                click(e) {
                  let weekIndex = column.label.split("|")[3];
                  let week = _self.tableData.SignInMgtWeekList[weekIndex];
                  _self.loadAbsenceCourseWeek(week.Week);
                },
              },
            },
            "缺勤率"
          ),
        ]
      );
      return oDiv;
    },
    renderGroupHeader(createElement, { column }, group) {
      var oDiv = createElement(
        "div",
        {
          class: {
            "header-merge": true,
          },
        },
        [group.length > 1 ? "合并课" : "单课"]
      );
      return oDiv;
    },
    groupBy(xs, f) {
      return xs.reduce(
        (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
        {}
      );
    },
    getMergeGroup(courseActivationList) {
      let newResult = [];
      let result = this.groupBy(courseActivationList, (c) => c.MergeGroup);
      for (let i = 0; i < Object.keys(result).length; i++) {
        let r = result[Object.keys(result)[i]];
        if (r && r.length > 0 && r[0].MergeGroup == 0) {
          r.forEach((g) => {
            newResult.push([g]);
          });
        }
        if (r && r.length > 0 && r[0].MergeGroup > 0) {
          newResult.push(r);
        }
      }

      return newResult;
    },
    renderCourseHeader(createElement, { column, $index }, ca) {
      let label = column.label.split("|")[1];
      return createElement(
        "span",
        {
          class: {
            "header-course": true,
          },
        },
        [createElement("a", [label])]
      );
    },
    getTotalAttendancePercentage(scope) {
      let attendanceTotal = 0.0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.AttendancePercentage) {
            attendanceTotal += r.AttendancePercentage * 1;
          }
        });
      }
      let count = studentList.length - 1;
      let rePercent = 0;
      if (count > 0) {
        rePercent = attendanceTotal / count;
      }
      return rePercent.toFixed(1);
    },
    getTotalAbsentPercentage(scope) {
      let attendanceTotal = 0.0;
      let studentList = this.tableData.SignInMgtStudentList;
      if (studentList && studentList.length > 0) {
        studentList.forEach((r) => {
          if (r.StudentId <= 0) {
            return;
          }

          if (r.AbsentPercentage) {
            attendanceTotal += r.AbsentPercentage * 1;
          }
        });
      }
      let count = studentList.length - 1;
      let rePercent = 0;
      if (count > 0) {
        rePercent = attendanceTotal / count;
      }
      return rePercent.toFixed(1);
    },
    pageSizeChange(value) {
      this.pageSize = value;
      this.currentPage = 1;
      this.loadPageData();
    },
    currentPageChange(value) {
      this.currentPage = value;
      this.loadPageData();
    },
    loadPageData(scrollToCurrent) {
      this.recordTotal = this.tableData.SignInMgtStudentList.length;
      if (this.recordTotal > this.pageSize) {
        this.displayPagination = true;
      }
      if (this.displayPagination) {
        let list = [];
        let pageCount = parseInt(this.recordTotal / this.pageSize);
        if (this.recordTotal % this.pageSize > 0) {
          pageCount++;
        }

        let startIndex = (this.currentPage - 1) * this.pageSize;
        let endIndex = startIndex + this.pageSize;
        for (let i = startIndex; i < endIndex; i++) {
          if (i < this.recordTotal) {
            list.push(this.tableData.SignInMgtStudentList[i]);
          }
        }
        this.pageListData = list;
      } else {
        this.pageListData = this.tableData.SignInMgtStudentList;
      }

      if (scrollToCurrent) {
        let index = this.tableData.SignInMgtWeekList.findIndex(
          (i) => i.IsCurrent
        );
        if (index >= 0) {
          this.$nextTick(() => {
            let table = this.$refs.signInMgTable;
            if (table && table.$el) {
              table.$el.scrollIntoView();
            }
          });
        }
      }
    },
    onStudentSelectedChange(value, studentId) {
      let evStudentList = this.studentsNotSent.filter(
        (student) => student.StudentId === studentId
      );

      let haveSelected = this.pageListData.some((item) => item._isSelected);
      let haveUnselected = this.pageListData.some((item) => !item._isSelected);
      this.isAllSelected = haveSelected && !haveUnselected;
      this.isIndeterminate = haveSelected && haveUnselected;

      if (value) {
        if (evStudentList.length === 0) {
          this.data.Students.push({
            StudentId: studentId,
            HasBeenSent: false,
          });
        }
      } else {
        if (evStudentList.length > 0) {
          evStudentList.forEach((evStudent) => {
            this.data.Students.remove(evStudent);
          });
        }
      }
    },
  },
};

export default {
  name: "studentSelector",
  mixins: [mixin_signInMangeTableMethods],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    courseType: {
      type: Number,
      default: undefined,
    },
    courseKey: {
      type: String,
      default: undefined,
    },
    isResending: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      rules: {
        CourseType: [
          {
            required: true,
            message: "请选择课程类型",
            trigger: "blur",
          },
        ],
        CourseKey: [
          {
            required: true,
            message: "请选择课程",
            trigger: "blur",
          },
        ],
        Keyword: [
          {
            required: false,
            message: "搜索学生电话",
            trigger: "blur",
          },
        ],
      },
      teacherUniversityCourseList: [],
      teacherTrainingCourseList: [],
      courseTypeList: Object.clone(
        this.GLOBAL.courseType.getOptions((item) => [1, 3].contains(item.value))
      ),
      courseList: [],
    };
  },
  computed: {
    courseTypeDisabled() {
      return this.isResending || this.isEdit || !!this.courseType;
    },
    courseKeyDisabled() {
      return this.isResending || this.isEdit || !!this.courseKey;
    },
    studentsNotSent() {
      return this.data.Students.filter((item) => !item.HasBeenSent);
    },
    studentsBeenSent() {
      return this.data.Students.filter((item) => item.HasBeenSent);
    },
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async loadTeacherCourseListFromServer() {
      try {
        let result = await getTeacherAllCourseList(null);
        if (!!result && result.success) {
          this.teacherUniversityCourseList = result.data.TeacherCourseList;
          this.teacherTrainingCourseList =
            result.data.TeacherTrainingCourseList;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadSignInManagementDataFromServer() {
      this.loading = true;
      this.pageListData = [];
      this.isAllSelected = false;
      this.isIndeterminate = false;
      this.studentsNotSent.forEach((item) => {
        if (!item.Id) this.data.Students.remove(item);
      });

      try {
        let result = await getSignInManagementData(
          null,
          this.USERMANAGER.teacherId,
          this.data.CourseId,
          this.data.CampusId,
          false
        );
        if (!!result && result.success) {
          this.tableData = result.data;
          this.loadPageData(true);

          var haveSelected = false;
          var haveUnselected = false;
          this.pageListData.forEach((item) => {
            let _isSelected = true;
            let _hasBeenSent = false;

            if (this.isResending) {
              if (
                this.studentsBeenSent.some(
                  (student) => student.StudentId === item.StudentId
                )
              ) {
                _isSelected = false;
                _hasBeenSent = true;
                haveUnselected = true;
              }
            } else if (this.isEdit) {
              _isSelected = false;

              if (
                this.data.Students.some(
                  (student) => student.StudentId === item.StudentId
                )
              ) {
                _isSelected = true;
              }

              if (
                this.studentsBeenSent.some(
                  (student) => student.StudentId === item.StudentId
                )
              ) {
                _hasBeenSent = true;
              }

              if (!_isSelected) haveUnselected = true;
            }

            this.$set(item, "_isSelected", _isSelected);
            this.$set(item, "_hasBeenSent", _hasBeenSent);

            let evStudentList = this.data.Students.filter(
              (student) => student.StudentId === item.StudentId
            );
            if (_isSelected) {
              haveSelected = true;

              if (evStudentList.length === 0) {
                this.data.Students.push({
                  StudentId: item.StudentId,
                  HasBeenSent: false,
                });
              }
            } else {
              if (evStudentList.length > 0) {
                evStudentList.forEach((evStudent) => {
                  this.data.Students.remove(evStudent);
                });
              }
            }
          });
          this.isAllSelected = haveSelected && !haveUnselected;
          this.isIndeterminate = haveSelected && haveUnselected;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async init() {
      if (
        this.teacherUniversityCourseList.length === 0 &&
        this.teacherTrainingCourseList.length === 0
      )
        await this.loadTeacherCourseListFromServer();
    },
    resetData() {
      this.courseTypeList = Object.clone(
        this.GLOBAL.courseType.getOptions((item) => [1, 3].contains(item.value))
      );
      this.loading = true;
    },
    reloadDataFromProps() {
      this.courseTypeList.forEach((item) => {
        switch (item.value) {
          case this.GLOBAL.courseType.university:
            this.$set(
              item,
              "haveCourses",
              this.teacherUniversityCourseList.length > 0
            );
            break;
          case this.GLOBAL.courseType.vocationalTraining:
            this.$set(
              item,
              "haveCourses",
              this.teacherTrainingCourseList.length > 0
            );
            break;
        }
      });

      if (!!this.courseType) this.data.CourseType = this.courseType;
      else {
        let matchedItems = this.courseTypeList.filter(
          (item) => item.haveCourses
        );
        if (matchedItems.length >= 1)
          this.data.CourseType = matchedItems[0].value;
        else this.data.CourseType = null;
      }

      this.$nextTick(async () => {
        let oldCourseKey = this.data.CourseKey;
        this.onCourseTypeChange();
        if (this.isResending || this.isEdit) this.data.CourseKey = oldCourseKey;
        else if (!!this.courseKey) this.data.CourseKey = this.courseKey;
        await this.loadSignInManagementDataFromServer();
      });
    },
    validate() {
      let isValid = true;

      let refFormStudentSelector = this.$vueRefStore.getChildrenRef(
        "formStudentSelector"
      );
      if (!!refFormStudentSelector) {
        refFormStudentSelector.validate((valid) => {
          isValid = valid;
        });
      }

      if (isValid && this.studentsNotSent.length === 0) {
        isValid = false;
        this.$message.error("请选择要发送的学生");
      }

      return isValid;
    },
    onCourseTypeChange() {
      let courseList = [];

      switch (this.data.CourseType) {
        case this.GLOBAL.courseType.university:
          courseList = this.teacherUniversityCourseList.map((item) => ({
            value: `${item.CourseId}`,
            text: `${item.CourseName}`,
            courseId: item.CourseId,
            campusId: null,
          }));
          break;
        case this.GLOBAL.courseType.vocationalTraining:
          this.teacherTrainingCourseList.forEach((item) => {
            if (courseList.some((course) => course.value === item.CourseId))
              return;

            courseList.push({
              value: `${item.CourseId}-${item.CampausId}`,
              text: `${item.CourseName}(${item.CampausName})`,
              courseId: item.CourseId,
              campusId: item.CampausId,
            });
          });
          break;
      }

      this.courseList = courseList;

      if (this.courseList.length > 0) {
        this.data.CourseId = this.courseList[0].courseId;
        this.data.CampusId = this.courseList[0].campusId;
      } else {
        this.data.CourseId = null;
        this.data.CampusId = null;
      }
    },
    onCurrentCourseKeyChange() {
      this.loadSignInManagementDataFromServer();
    },
    onSearch() {
      let item = this.tableData.SignInMgtStudentList.find(
        (i) => i.StudentName.indexOf(this.data.Keyword) >= 0
      );
      if (item) {
        let className = "student-" + item.StudentId;
        let nodes =
          this.$refs.signInMgTable.$el.getElementsByClassName(className);
        if (nodes.length > 0) {
          nodes[0].scrollIntoView();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-studentSelector-searchInput {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/emailVideo/studentSelector.vue